import PropTypes from 'prop-types';
import React, { Suspense, useEffect, useEffectEvent } from 'react';
import { CHAT_VIEW_STATES, useCurrentChat } from '@guuru/chat-web';
import BottomBar from '../BottomBar';
import ChatRateBadExpert from './ChatRateBadExpert';
import ChatRateExpert from './ChatRateExpert';

const RateSection = function ({ isUser, doBefore = () => {} }) {
  const { viewState } = useCurrentChat();

  const isRateStep =
    isUser &&
    [CHAT_VIEW_STATES.rate, CHAT_VIEW_STATES.rateBad].includes(viewState);
  const handleBeforeRate = useEffectEvent(doBefore);

  useEffect(() => {
    if (isRateStep) handleBeforeRate();
  }, [isRateStep]);

  if (!isRateStep) {
    return null;
  }

  return (
    <BottomBar isUser={isUser}>
      <section role="alert">
        <Suspense>
          {viewState === CHAT_VIEW_STATES.rate ? (
            <ChatRateExpert />
          ) : (
            <ChatRateBadExpert />
          )}
        </Suspense>
      </section>
    </BottomBar>
  );
};

RateSection.propTypes = {
  isUser: PropTypes.bool.isRequired,
  doBefore: PropTypes.func,
};

export default RateSection;
